// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-620cb70f] .el-form-item__label {\n  width: 110px !important;\n}\n[data-v-620cb70f] .el-input {\n  width: 90%;\n}\n", ""]);
// Exports
module.exports = exports;
